export default {
  notifications: {
    page: {
      title: 'Уведомления',
      settings: 'Настройки',
      settingsTitle: 'Настройки уведомлений',
    },
    bell: {
      ariaUnread: '{count} непрочитанных уведомлений',
      ariaNone: 'Нет непрочитанных уведомлений',
      title: 'Уведомления',
      loading: 'Загрузка…',
      empty: 'Нет уведомлений',
      markAllRead: 'Прочитать все',
      viewAll: 'Все уведомления',
    },
    list: {
      emptyTitle: 'Нет уведомлений',
      emptyDescription: 'У вас пока нет уведомлений',
    },
    item: {
      markAsRead: 'Отметить прочитанным',
      justNow: 'только что',
      minutesAgo: '{count} мин назад',
      hoursAgo: '{count} ч назад',
      daysAgo: '{count} дн назад',
    },
    preferences: {
      pushTitle: 'Push на этом устройстве',
      pushNotSupported: 'Не поддерживается этим браузером',
      pushEnabled: 'Уведомления включены на этом устройстве',
      pushBlocked: 'Заблокировано браузером. Разрешите в настройках сайта',
      pushAllow: 'Разрешить уведомления на этом устройстве',
      chooseHow: 'Выберите, как получать уведомления',
      messengers: 'Мессенджеры',
      telegramTitle: 'Telegram',
      telegramDescription: 'Получать уведомления через Telegram-бот',
      whatsappTitle: 'WhatsApp',
      whatsappComingSoon: 'Скоро',
      connect: 'Подключить',
      disconnect: 'Отключить',
      cancel: 'Отмена',
      save: 'Сохранить',
      saving: 'Сохраняем…',
      channels: {
        web: {
          name: 'В приложении',
          description: 'Уведомления в реальном времени в браузере',
        },
        push: {
          name: 'Push на телефоне',
          description: 'Уведомления на телефоне даже когда приложение закрыто',
        },
        email: {
          name: 'Email',
          description: 'Получать уведомления на email',
        },
        sms: {
          name: 'SMS',
          description: 'Важные уведомления в SMS',
        },
        telegram: {
          name: 'Telegram',
          description: 'Получать уведомления через Telegram-бот',
        },
        whatsapp: {
          name: 'WhatsApp',
          description: 'Уведомления в WhatsApp',
        },
      },
    },
  },
};
